import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { MaxProductGroupDiscountCheckModel } from '../models/max-product-group-discounts';

@Injectable({
  providedIn: 'root'
})
export class MaxProductGroupDuscountDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public checkProductStyleInClinicExists(request: MaxProductGroupDiscountCheckModel, cancellation: Promise<any>): Promise<boolean> {
    return this.httpClient.getJsonAsync<boolean>('MaxProductGroupDiscounts/SameSetupExists', request, cancellation, false);
  }
}
